import {
  AUTH_BASE_URL,
  PARENT_APPLICATION_ID,
} from '@hrms/common/constant/global';
import { apiService } from '@hrms/common/service';
import {
  GetUserInterface,
  GetUserRoleDetailsResponseInterface,
  UserProfileInterface,
} from './types';

export const getUserProfileData: GetUserInterface = async () => {
  const response = await apiService.get<UserProfileInterface>({
    path: `${AUTH_BASE_URL}api/v1/auth/get-user-by-token`,
    params: {
      parentApplicationId: PARENT_APPLICATION_ID ?? '',
    },
  });
  const { data } = response;
  return data;
};

export const getUserRoleDetails = async (id: string) => {
  const response = await apiService.get<GetUserRoleDetailsResponseInterface>({
    path: 'api/v1/employee/profile/roleDetails',
    params: { id },
  });
  return response.data.roleDetails;
};
